import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { DateControlComponent } from './date-control/date-control.component';
import { DateFormControlComponent } from './date-form-control.component';



@NgModule({
  declarations: [
    DateFormControlComponent,
    DateControlComponent
  ],
  exports: [
    DateFormControlComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatDatepickerModule
  ]
})
export class DateFormControlModule { }
